<template>
  <div>
    <v-card-title class="pt-0 pb-4" :style="`color:${config.COLORS.BLACK}; font-weight: 500; letter-spacing: -0.02em;`">
      <v-img max-height="35" max-width="35" :src="item.logo" class="mr-2"> </v-img>
      {{ customName }}
    </v-card-title>
    <v-card-subtitle class="pt-2 pb-0" style="line-height: 0.8rem">
      <span v-if="!openingHours" style="color: red; font-weight: 500">
        {{ $t('sitedetails.closed') }}
      </span>
      <span v-if="openingHours" style="color: green; font-weight: 500">
        {{ $t('sitedetails.open') }} {{ $t('sitedetails.from') }} {{ openingHours.start }} {{ $t('sitedetails.to') }} {{ openingHours.end }}
      </span>
    </v-card-subtitle>
    <v-card-subtitle class="pt-3 pb-0" style="line-height: 0.9rem; color: rgba(0, 0, 0, 0.6)">{{ item.address }}</v-card-subtitle>
  </div>
</template>

<script>
import moment from 'moment';
import { Config } from '@/config';

export default {
  props: ['item', 'name'],
  data() {
    return {
      config: Config,
    };
  },
  computed: {
    customName() {
      if (this.name !== undefined) {
        return this.item[this.name];
      }
      return this.item.full_name;
    },
    openingHours() {
      const isoDow = moment().isoWeekday();
      if (
        this.item.opening_hours !== undefined &&
        this.item.opening_hours[isoDow] !== undefined &&
        this.item.opening_hours[isoDow][0] !== undefined &&
        this.item.opening_hours[isoDow][1] !== undefined
      ) {
        return { start: this.item.opening_hours[isoDow][0], end: this.item.opening_hours[isoDow][1] };
      }
      return false;
    },
  },
  watch: {},
  mounted() {},
  created() {},
  methods: {},
};
</script>
